import { render } from "./UserEditor.vue?vue&type=template&id=f99de1cc&scoped=true"
import script from "./UserEditor.vue?vue&type=script&lang=js"
export * from "./UserEditor.vue?vue&type=script&lang=js"

import "./UserEditor.vue?vue&type=style&index=0&id=f99de1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99de1cc"]])

export default __exports__